import SpeakersComponent from "./speakers.component";

export default SpeakersComponent;
